module.exports = __webpack_public_path__ + "static/media/reward-i.ff530e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/reward-i.png
// module id = 1865
// module chunks = 0